import { Layout } from "antd";
import moment from "moment";
import { FC } from "react";
import { BUS_ASSOCIATION_INFO } from "../../../constants/constants";

const { Footer } = Layout;

const FooterComponent: FC = () => {
  return (
    <Footer className="hidden-print" style={{ textAlign: "center" }}>
      {BUS_ASSOCIATION_INFO.name_english} © {moment().year()} Engida Travel
      Technology
    </Footer>
  );
};

export default FooterComponent;
